import { render } from "./RedPlacemat.svg?vue&type=template&id=3d3393fd"
const script = {}
script.render = render

export default script